"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.login2FAReducer = exports.initialLoing2FAState = void 0;
const types_1 = require("../types");
const login2FAAction_1 = require("../actions/login2FAAction");
exports.initialLoing2FAState = {
    inputData: undefined,
    isScreenDataLoaded: false,
    showLayout: false,
    login2faPopupData: {
        show: false,
        titleId: '',
        contentId: '',
        toggleTopRightCancel: () => { },
        footerType: '1',
        leftBtnLabelId: '',
        leftBtnCallback: () => { },
        rightBtnLabelId: '',
        rightBtnCallback: () => { },
    },
    layoutStatus: types_1.LayoutStatus.NULL,
    maskedMobileNo: '',
    otpCode: '',
    authorizationId: '',
    authorizationTypeCode: '',
    authorizationReference: '',
    transactionId: '',
    refcode: '',
};
const login2FAReducer = (state = exports.initialLoing2FAState, action) => {
    switch (action.type) {
        // case Login2FAType.SET_ERROR_MSG:
        //     return {
        //         ...state,
        //         systemMessages: action.payload,
        //     }
        // case Login2FAType.CLEAR_ERROR_MSG:
        //     return {
        //         ...state,
        //         systemMessages: undefined,
        //     }
        case login2FAAction_1.Login2FAType.PREPARE_START_LOGIN_2FA_WORKFLOW_DATA:
            return Object.assign(Object.assign({}, state), { inputData: action.payload });
        case login2FAAction_1.Login2FAType.START_LOGIN_2FA_WORKFLOW:
            return Object.assign({}, state);
        case login2FAAction_1.Login2FAType.END_LOGIN_2FA_WORKFLOW:
        case login2FAAction_1.Login2FAType.CANCEL_LOGIN_2FA_WORKFLOW:
            return Object.assign(Object.assign({}, state), { showLayout: false, login2faPopupData: {
                    show: false,
                    titleId: '',
                    contentId: '',
                    toggleTopRightCancel: () => { },
                    footerType: '1',
                    leftBtnLabelId: '',
                    leftBtnCallback: () => { },
                    rightBtnLabelId: '',
                    rightBtnCallback: () => { },
                }, layoutStatus: types_1.LayoutStatus.NULL, maskedMobileNo: '', otpCode: '', authorizationId: '', authorizationTypeCode: '', authorizationReference: '', transactionId: '' });
        case login2FAAction_1.Login2FAType.SHOW_LOGIN_2FA:
            return Object.assign(Object.assign({}, state), { showLayout: true });
        case login2FAAction_1.Login2FAType.DISMISS_LOGIN_2FA:
            return Object.assign(Object.assign({}, state), { showLayout: false });
        case login2FAAction_1.Login2FAType.SET_LOGIN_2FA_POPUP_DATA:
            return Object.assign(Object.assign({}, state), { login2faPopupData: action.payload });
        case login2FAAction_1.Login2FAType.SET_LAYOUT_STATUS:
            return Object.assign(Object.assign({}, state), { layoutStatus: action.payload });
        case login2FAAction_1.Login2FAType.SET_MASLED_MOBILE_NO:
            return Object.assign(Object.assign({}, state), { maskedMobileNo: action.payload });
        case login2FAAction_1.Login2FAType.SET_OTP_CODE:
            return Object.assign(Object.assign({}, state), { otpCode: action.payload });
        case login2FAAction_1.Login2FAType.SET_AUTHORIZATION_ID:
            return Object.assign(Object.assign({}, state), { authorizationId: action.payload });
        case login2FAAction_1.Login2FAType.SET_AUTHORIZATION_TYPE_CODE:
            return Object.assign(Object.assign({}, state), { authorizationTypeCode: action.payload });
        case login2FAAction_1.Login2FAType.SET_AUTHORIZATION_REFERENCE:
            return Object.assign(Object.assign({}, state), { authorizationReference: action.payload });
        case login2FAAction_1.Login2FAType.SET_TRANSACTION_ID:
            return Object.assign(Object.assign({}, state), { transactionId: action.payload });
        case login2FAAction_1.Login2FAType.TOGGLE_LOST_OR_CHANGED:
            return Object.assign(Object.assign({}, state), { layoutStatus: types_1.LayoutStatus.LOST_OR_CHANGED });
        case login2FAAction_1.Login2FAType.TOGGLE_CLOSE_LOST_OR_CHANGED:
            return Object.assign(Object.assign({}, state), { layoutStatus: types_1.LayoutStatus.OTP });
        case login2FAAction_1.Login2FAType.SET_REFCODE:
            return Object.assign(Object.assign({}, state), { refcode: action.payload });
        default:
            return state;
    }
};
exports.login2FAReducer = login2FAReducer;
